import { createCompanyDetailsSlice } from 'common/stores/redux/ContractorCompanyDetails';

const adminContractorCompanyDetailsSlice = createCompanyDetailsSlice(
    'adminContractorCompany'
);

export const {
    init,
    replace,
    addNote,
    addRating,
    updateNote,
    addFile,
    removeFile,
    addQualification,
    removeQualification,
    addBlocklistItem,
    removeBlocklistItem,
    replaceBlocklistItem,
} = adminContractorCompanyDetailsSlice.actions;

export default adminContractorCompanyDetailsSlice.reducer;
